import { ReactElement } from 'react';

import cn from 'classnames';

import style from './styles.module.scss';

export const Skeleton = (): ReactElement => (
  <div className={style.Container}>
    <div className={style.LeftSide}>
      <div
        className={cn(style.SkeletonRound, style.desktop)}
        style={{ width: '180px' }}
      />
      <div
        className={cn(style.SkeletonRound, style.desktop)}
        style={{ width: '24px' }}
      />
      <div
        className={cn(style.SkeletonRound, style.desktop)}
        style={{ width: '70px' }}
      />
      <div
        className={cn(style.SkeletonRound, style.tablet)}
        style={{ width: '140px' }}
      />
      <div
        className={cn(style.SkeletonRound, style.mobile)}
        style={{ width: '24px' }}
      />
    </div>
    <div className={style.RightSide}>
      <div
        className={cn(style.SkeletonRound, style.desktop)}
        style={{ width: '400px', height: '40px' }}
      />
      <div className={cn(style.SkeletonRound)} style={{ width: '24px' }} />
      <div
        className={cn(style.SkeletonRound, style.tabletAndMobile)}
        style={{ width: '24px' }}
      />
      <div
        className={cn(style.SkeletonRound)}
        style={{ width: '40px', height: '40px' }}
      />
    </div>
  </div>
);
